import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PromiseStatuses } from "../../../utils";
import { CertDemeterResponseDTO, createCertDemeterDTO, GetAllCertificatesFiltersDTO, updateCertDemeterDTO } from "./dataService/dto";
import { NewDemeterService } from "./dataService/service";
interface DemeterState {
    // FILTERS
    getAllCertificatesFilters: GetAllCertificatesFiltersDTO
    getAllCertificatesResponse?: CertDemeterResponseDTO
    createCertDemeter: createCertDemeterDTO
    updateCertDemeter: updateCertDemeterDTO
    idSelectedCert?: string
    demeterCreationStatus: PromiseStatuses
    demeterUpdateStatus: PromiseStatuses
    demeterGetAllStatus: PromiseStatuses
}

const initialState: DemeterState = {
    getAllCertificatesFilters: {
        itemsPerPage: 100,
        page: 0,
        order: true
    },
    createCertDemeter: {},
    updateCertDemeter: {},
    demeterCreationStatus: 'idle',
    demeterGetAllStatus: 'idle',
    demeterUpdateStatus: 'idle'
}

export const CreateDemeter = createAsyncThunk(
    'demeter/CreateDemeter',
    async (body: createCertDemeterDTO, thunkApi): Promise<void> => {
        const demeterService = NewDemeterService()

        return demeterService.CreateDemeter(body).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const UpdateDemeter = createAsyncThunk(
    'demeter/UpdateDemeter',
    async (request: { body: updateCertDemeterDTO, id: string }, thunkApi): Promise<void> => {
        const demeterService = NewDemeterService()

        return demeterService.UpdateDemeter(request.body, request.id).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const GetAllDemeter = createAsyncThunk(
    'demeter/GetAllDemeter',
    async (filters: GetAllCertificatesFiltersDTO, thunkApi): Promise<CertDemeterResponseDTO> => {
        const demeterService = NewDemeterService()
        return demeterService.GetAllDemeter(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

const DemeterSlice = createSlice({
    name: 'demeter/slice',
    initialState,
    reducers: {
        //Create
        setCreateCustomerId: (state, action) => {
            state.createCertDemeter.customerId = action.payload
        },
        setCreateYear: (state, action) => {
            state.createCertDemeter.year = action.payload
        },
        setCreateStartingDate: (state, action) => {
            state.createCertDemeter.startingDate = action.payload
        },
        setCreateEdingDate: (state, action) => {
            state.createCertDemeter.endingDate = action.payload
        },
        setCreateClientType: (state, action) => {
            state.createCertDemeter.operatorType = action.payload
        },
        setCreateCompanyType: (state, action) => {
            state.createCertDemeter.companyType = action.payload
        },
        setCreateStake: (state, action) => {
            state.createCertDemeter.rate = action.payload
        },
        setCreatePrivacyProtocol: (state, action) => {
            state.createCertDemeter.privacyProtocolId = action.payload
        },
        setCreateDemeterNote: (state, action) => {
            state.createCertDemeter.demeterNote = action.payload
        },
        setCreateCodexNote: (state, action) => {
            state.createCertDemeter.codexNote = action.payload
        },
        setCreateTerzeParti: (state, action) => {
            state.createCertDemeter.thirdParty = action.payload
        },
        setCreateProcessingType: (state, action) => {
            state.createCertDemeter.processingType = action.payload
        },
        setCreateVisitId: (state, action) => {
            state.createCertDemeter.inspectionVisitId = action.payload
        },

        //Update
        setUpdateYear: (state, action) => {
            state.updateCertDemeter.year = action.payload
        },
        setUpdateStartingDate: (state, action) => {
            state.updateCertDemeter.startingDate = action.payload
        },
        setUpdateEdingDate: (state, action) => {
            state.updateCertDemeter.endingDate = action.payload
        },
        setUpdateClientType: (state, action) => {
            state.updateCertDemeter.operatorType = action.payload
        },
        setUpdateCompanyType: (state, action) => {
            state.updateCertDemeter.companyType = action.payload
        },
        setUpdateStake: (state, action) => {
            state.updateCertDemeter.rate = action.payload
        },
        setUpdatePrivacyProtocol: (state, action) => {
            state.updateCertDemeter.privacyProtocolId = action.payload
        },
        setUpdateDemeterNote: (state, action) => {
            state.updateCertDemeter.demeterNote = action.payload
        },
        setUpdateCodexNote: (state, action) => {
            state.updateCertDemeter.codexNote = action.payload
        },
        setUpdateTerzeParti: (state, action) => {
            state.updateCertDemeter.thirdParty = action.payload
        },
        setUpdateProcessingType: (state, action) => {
            state.updateCertDemeter.processingType = action.payload
        },
        setUpdateVisitId: (state, action) => {
            state.updateCertDemeter.inspectionVisitId = action.payload
        },
        setUpdateIdDemeter: (state, action) => {
            state.idSelectedCert = action.payload
        },
        resetCreateStatus: (state) => {
            state.demeterCreationStatus = 'idle'
        },
        resetUpdateStatus: (state) => {
            state.demeterUpdateStatus = 'idle'
        },
        resetGetAllStatus: (state) => {
            state.demeterGetAllStatus = 'idle'
        },
    },
    extraReducers(builder) {
        builder
            //CREATE
            .addCase(CreateDemeter.pending, (state) => {
                state.demeterCreationStatus = 'loading'
            })
            .addCase(CreateDemeter.fulfilled, (state, action) => {
                state.demeterCreationStatus = 'successfully'
            })
            .addCase(CreateDemeter.rejected, (state) => {
                state.demeterCreationStatus = 'failed'
            })
            //GET ALL
            .addCase(GetAllDemeter.pending, (state) => {
                state.demeterGetAllStatus = 'loading'
            })
            .addCase(GetAllDemeter.fulfilled, (state, action) => {
                state.demeterGetAllStatus = 'successfully'
                state.getAllCertificatesResponse = action.payload
            })
            .addCase(GetAllDemeter.rejected, (state) => {
                state.demeterGetAllStatus = 'failed'
            })
            //UPDATE
            .addCase(UpdateDemeter.pending, (state) => {
                state.demeterUpdateStatus = 'loading'
            })
            .addCase(UpdateDemeter.fulfilled, (state, action) => {
                state.demeterUpdateStatus = 'successfully'
            })
            .addCase(UpdateDemeter.rejected, (state) => {
                state.demeterUpdateStatus = 'failed'
            })
    }
})

export const {
    setCreateClientType,
    setCreateCodexNote,
    setCreateCompanyType,
    setCreateDemeterNote,
    setCreateEdingDate,
    setCreatePrivacyProtocol,
    setCreateStake,
    setCreateStartingDate,
    setCreateTerzeParti,
    setCreateYear,
    setCreateVisitId,
    setCreateCustomerId,
    setCreateProcessingType,
    //UPDATE
    setUpdateClientType,
    setUpdateCodexNote,
    setUpdateCompanyType,
    setUpdateDemeterNote,
    setUpdateEdingDate,
    setUpdatePrivacyProtocol,
    setUpdateStake,
    setUpdateStartingDate,
    setUpdateTerzeParti,
    setUpdateYear,
    setUpdateProcessingType,
    setUpdateVisitId,
    setUpdateIdDemeter,
    resetCreateStatus,
    resetGetAllStatus,
    resetUpdateStatus
} = DemeterSlice.actions

export default DemeterSlice.reducer